<template>
    <div class="news">
        <div class="news_content">
            <div class="title">
                <p class="cn">{{title.titleCn}}</p>
                <p class="en">{{title.titleEn}}</p>
            </div>
            <div class="content">
                <div class="top-news" @click="goDetail(topNews)" v-show="topNews.newsId">
                    <div class="img-area">
                        <img :src="topNews.image" alt="">
                    </div>
                    <div class="content-area">
                        <h6>{{isCn ? topNews.titleChina : topNews.titleEng}}</h6>
                        <p class="weak">{{topNews.pubTime}}</p>
                        <p>{{isCn ? topNews.cnBriefIntro : topNews.enBriefIntro}} </p>
                    </div>
                    <div class="goto-area">
                        <strong v-text="'READ MORE 》'"></strong>
                    </div>
                </div>
                <div class="other-news" v-show="newsList.length">
                    <div v-for="news in newsList"
                        class="news-item"
                        :key="news.newsId"
                        @click="goDetail(news)"
                    >
                        <div class="content-area">
                            <h6>{{isCn ? news.titleChina : news.titleEng}}</h6>
                            <p class="weak">{{news.pubTime}}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="get_more">
                <span @click="moreNews" class="btn-more">MORE<q-icon name="add"></q-icon></span>
            </div>
        </div>
    </div>
</template>

<script>
import getLang from '@/utils/main/language';
import Layout from '@/views/Layout.vue';
import ajax from '@/utils/ajax';
import { gDate } from '@/utils/format';

export default {
    name: 'customListBlock',
    components: {
        Layout,
    },
    props: {
        newsTitle: Object,
    },
    data() {
        return {
            isCn: window.localStorage.getItem('show-lang') !== 'en',
            lang: getLang(),
            topNews: {},
            newsList: [],
            title: this.$props.newsTitle,
        };
    },
    created() {
        ajax.get('/web/news/news_list.json', {
            pageSize: 5,
            page: 1,
        }).then((result) => {
            this.newsList = result.dataList.map((v) => {
                v.pubTime = gDate.datetimeFormat(v.pubTime, 'YYYY-MM-DD');
                v.cnBriefIntro = v.cnBriefIntro.length > 100 ? `${v.cnBriefIntro.substr(0, 100)} ...` : v.cnBriefIntro;
                v.enBriefIntro = v.cnBriefIntro.length > 200 ? `${v.cnBriefIntro.substr(0, 200)} ...` : v.enBriefIntro;
                v.titleChina = v.titleChina.length > 50 ? `${v.titleChina.substr(0, 50)} ...` : v.titleChina;
                v.titleEng = v.titleEng.length > 100 ? `${v.titleEng.substr(0, 100)} ...` : v.titleEng;
                return v;
            });
            this.topNews = this.newsList.shift();
        }).catch(() => {});
    },
    methods: {
        moreNews() {
            this.$router.push({ name: 'newsList' });
        },
        goDetail(news) {
            this.$router.push({ name: 'newsDetail', params: { id: news.newsId } });
        },
    },
};
</script>
<style lang="less" scoped>
.news_content {
    width: 1000px;
    margin: 0 auto;
    .title {
        width: 100%;
        margin-bottom: 20px;
        p {
            width: 100%;
            text-align: center;
            font-size:20px;
        }
        .cn {
            font-weight:600;
            color:rgba(74,74,74,1);
            &:first-letter {
                // vertical-align: bottom;
                font-size: 36px;
            }
        }
        .en {
            font-weight:600;
            color:rgba(199,31,75,1);
            letter-spacing: -1.2px;
        }
    }
    .content{
        width: 100%;
        display: flex;
        justify-content: space-between;
        margin-top: 5px;
        .top-news{
            cursor: pointer;
            flex: 0 0 450px;
            .img-area {
                width: 100%;
                height: 240px;
                img {
                    width: 100%;
                    height: 100%;
                }
            }
            .content-area {
                margin: 10px 0 16px;
                h6 {
                    color: #4A4A4A;
                    font-weight: bold;
                    height: 48px;
                    line-height: 24px;
                    font-size: 14px;
                    margin-bottom: 4px;
                }
                p {
                    font-size: 13px;
                    color: rgba(74,74,74,0.85);
                    line-height: 16px;
                }
                p.weak {
                    color: rgba(74,74,74,0.65);
                    margin-bottom: 10px;
                }
            }
            .goto-area {
                strong {
                    color: #B31A20;
                    line-height: 20px;
                    font-size: 16px;
                    font-weight: bold;
                }
            }
        }
        .other-news{
            flex: 0 0 450px;
            padding: 0 11px;
            .news-item {
                cursor: pointer;
                .content-area {
                    padding: 15px 0;
                    border-bottom: 1px solid #f1f1f1;
                }
                h6 {
                    color: #4A4A4A;
                    font-weight: bold;
                    height: 48px;
                    line-height: 24px;
                    font-size: 16px;
                    margin-bottom: 4px;
                    &:hover {
                        color: #B31A20;
                    }
                }
                p.weak {
                    font-size: 13px;
                    color: rgba(74,74,74,0.65);
                    line-height: 16px;
                }
            }
        }
    }
    .get_more{
        width: 100%;
        display: flex;
        justify-content: center;
        margin-top: 10px;
        .btn-more {
            display: inline-block;
            width: 128px;
            height: 32px;
            border:1px solid rgba(199,31,75,1);
            font-size:14px;
            font-weight:400;
            color:rgba(199,31,75,1);
            text-align: center;
            line-height: 32px;
            cursor: pointer;
        }
    }
}
</style>
